export const getSeriesKey = (idPoint?: number, parameterName?: string): string | null => {
  if (idPoint == null || !parameterName) {
    return null;
  }

  return `${idPoint}:${parameterName}`;
};
